class InlineVideoControl {
	element: HTMLElement;
	videoId: string;
	video: HTMLElement | null;
	iframe: HTMLIFrameElement | null;
	player: InstanceType<typeof window.Vimeo.Player> | null;

	constructor(element: HTMLElement) {
		this.element = element;
		this.videoId = element.getAttribute('data-video-id') as string;
		this.video = document.getElementById(this.videoId);
		this.iframe = this.video?.querySelector('iframe') ?? null;
		this.player = null;
	}

	private getPlayer(): InstanceType<typeof window.Vimeo.Player> | null {
		if (!this.player && window.Vimeo?.Player && this.iframe) {
			this.player = new window.Vimeo.Player(this.iframe);
		}
		return this.player;
	}

	init() {
		if (!this.iframe) return;
		this.element.addEventListener('click', () => this.togglePlay());
	}

	togglePlay(): void {
		const player = this.getPlayer();
		if (!player) return;

		const paused = this.element.getAttribute('data-paused') === 'true';
		if (paused) {
			this.element.setAttribute('data-paused', 'false');
			this.element.setAttribute('aria-label', 'Pause video');
			this.element.setAttribute('aria-pressed', 'false');
			player.play();
		} else {
			this.element.setAttribute('data-paused', 'true');
			this.element.setAttribute('aria-label', 'Play video');
			this.element.setAttribute('aria-pressed', 'true');
			player.pause();
		}
	}
}

function initInlineVideoControls() {
	document.querySelectorAll('.inline-video-control').forEach((element) => {
		if ((element as HTMLElement).dataset.initialized) return;
		(element as HTMLElement).dataset.initialized = 'true';
		const inlineVideoControl = new InlineVideoControl(element as HTMLElement);
		inlineVideoControl.init();
	});
}

window.addEventListener('load', initInlineVideoControls);
window.addEventListener('rocket-allScriptsLoaded', initInlineVideoControls);
